module.exports = __webpack_public_path__ + "static/media/banner-3-rp.415fa7d9.jpg";